import React from 'react'
import Updrs_table  from './updrs_table'
import SideMenu from '../../utilities/sideMenu/menu'
import Part from './Part'
import Part1 from './part1.json'
import Part2 from './part2.json'
import Part3 from './part3.json'
import Part4 from './part4.json'
class Updrs extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }
    handleScore = (name,score)=>{

        this.setState((prevState)=>({
            ...prevState,
            [name]:score
        }), ()=>{
            this.props.handler('updrs',this.state)
        })
    }
    
    
    onChange =  async (event)=>{
        const {name,value} = event.target
        
       await this.setState((prevState)=>({
            ...prevState,
            
           
                [name]:value
            
        }))
        if (name == 'p3_3c' && value =='No'){
           await this.setState((prevState)=>({
                ...prevState,
                'p3_3c_minutes_lev_dose':""
            }))
        }
        if (name == "p3_dyskinesia_impact" && value =='No'){
          await  this.setState((prevState)=>({
                ...prevState,
                'p3_dyskinesia_impact_interfere_ratings':""
            }))
        }
        this.props.handler('updrs',this.state)
    }
    componentDidMount(){
        if(this.props.data!= null){
            this.setState(this.props.data)
        }
    }
    
    componentDidUpdate(prevProps, prevState){
        // if (prevState != this.state){
        //     this.props.handler('updrs',this.state)
        // }
        // if (prevState != this.state){
        // }
    }
    render() {
        return (
            <div>
                <SideMenu defaultKey={'p1'}>
                    <Part disabled={this.props.disabled} indexKey={'p1'} title={'Part 1: Non-Motor Aspects of Experiences of Daily Living (nM-EDL)'} data={this.props.data}onChange={this.onChange} score={this.handleScore} questions={Part1} score_name={'p1_score'}/>
                    <Part disabled={this.props.disabled} indexKey={'p2'} title={'Part 2: Motor Aspects of Experiences of Daily Living (M-EDL)' } data={this.props.data} onChange={this.onChange} score={this.handleScore} questions={Part2} score_name={'p2_score'}/>
                    <Part disabled={this.props.disabled} indexKey={'p3'} title={'Part 3: Motor Examination' } data={this.props.data} onChange={this.onChange} score={this.handleScore} questions={Part3} score_name={'p3_score'}/>
                    <Part disabled={this.props.disabled} indexKey={'p4'} title={'Part 4 Motor Complications' } data={this.props.data} onChange={this.onChange} score={this.handleScore} questions={Part4} score_name={'p4_score'}/>
                </SideMenu> 
                
            </div>
        )
    }
}
Updrs.defaultProps = {
    data:null,
    disabled:false
}
export default Updrs